export default __webpack_public_path__ + "static/media/download_metadata.979bbecb.gif";